import { View, Text, TouchableOpacity, Platform } from "react-native";
import React, { useMemo } from "react";
import TutorialHeader from "../../components/tutorial/TutorialHeader";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import * as Linking from "expo-linking";

import {
  changeHeaderColor,
  showBackButton,
  showBackButtonWithFunction,
  showBackButtonWithProps,
} from "../../redux/header/headerAction";
import { orange, shadowSm, white } from "../../colors";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TutorialBody from "../../components/tutorial/TutorialBody";
import { ScrollView } from "react-native-gesture-handler";
import { useState } from "react";
import getTutorialDetail from "../../api/tutorial/getTutorialDetails";
import VideoDropdown from "../../components/custom/VideoDropdown";
import MyVideo from "../../components/MyVideo";
import PdfModal from "../../components/modals/PdfModal";
import MyText from "../../components/custom/MyText";
import BuyTutorial from "../../components/modals/BuyTutorialModal";
import MyButton from "../../components/custom/MyButton";
export default function Tutorial({ route }) {
  const navigation = useNavigation();
  const main = useSelector((store) => store.main);
  const dispatch = useDispatch();
  const { params, children } = route;
  const isFocused = useIsFocused();
  const [change, setChange] = useState(false);
  const [item, setItem] = useState({});
  const [document, setDocument] = useState([]);
  const [liked, setLiked] = useState(null);

  const [pdfModal, setPdfModal] = useState({ url: "", open: false });
  const [buyModal, setBuyModal] = useState({
    status: true,
    id: params.id,
    open: false,
    store: { price: 0, priceOffer: 0 },
  });
  useEffect(() => {
    getTutorialDetail(params.id)
      .then(({ data }) => {
        if (data.status === 200) {
          if (data.data.kind === "monetary" && !data.isBuy) {
            setBuyModal((prev) => ({
              ...prev,
              store: data.store,
              open: true,
              status: false,
            }));
          
          } else {
            setBuyModal((prev) => ({
              status: true,
              id: params.id,
              open: false,
              store: { price: 0, priceOffer: 0 },
            }));
          }
          setItem(data.data);
          setDocument([...data.document]);

          if (data.liked) {
            setLiked(data.liked[0].kind);
          }
        }
      })
      .catch((error) => {});
  }, [change]);
  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor(white));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
    }
  }, [isFocused]);
  let fileIndex = 0;
  let videoIndex = 0;

  const openModal = (url) => {
    setPdfModal((prev) => ({ ...prev, open: true, url: url }));
  };

  return (
    <ScrollView
      showsVerticalScrollIndicator={false}
      contentContainerStyle={{ alignItems: "center" }}
    >
      <TutorialHeader
        liked={liked || 1}
        image={item.picURl}
        title={main.rtl ? item.titleFa : item.titleEn}
        age={item.Ages || 1}
        publisherName={item.publisherName || ""}
        readTime={item.timeToRead || "1 دقیقه"}
      />
      {item.Ages !== undefined && (
        <TutorialBody
          liked={liked}
          id={params.id}
          body={main.rtl ? item.descreptionsFa : item.descreptionsEn}
          videoUrl={main.rtl ? item.videoURLFa : item.videoURLEn}
          setChange={setChange}
          change={change}
        />
      )}
      {document !== undefined &&
      document !== null &&
      document.length > 0 &&
      buyModal.status ? (
        <View
          style={{
            width: "96%",
            alignItems: "center",
            justifyContent: "center",
            padding: 10,
            borderWidth: 1,
            borderColor: orange,
            borderRadius: 10,
            marginVertical: 20,
          }}
        >
          <MyText>مستندات آموزش</MyText>

          {document.map((item, index) =>
            item.type === "video" ? (
              <VideoDropdown key={index} title={`فیلم ${(videoIndex += 1)}`}>
                <View
                  style={{
                    borderWidth: 1,
                    borderRadius: 10,
                    borderColor: "#ddd",
                  }}
                >
                  <MyVideo url={item.url} />
                </View>
              </VideoDropdown>
            ) : (
              <TouchableOpacity
                key={index}
                style={{
                  borderWidth: 1,
                  borderColor: "#eee",
                  padding: 10,
                  width: "96%",
                  marginVertical: 10,
                  borderRadius: 15,
                }}
                onPress={() =>
                  Platform.OS === "web"
                    ? Linking.openURL(item.url)
                    : openModal(item.url)
                }
              >
                <MyText>{`فایل ${(fileIndex += 1)}`}</MyText>
              </TouchableOpacity>
            )
          )}
        </View>
      ) : (
        <View style={{ width: "95%", alignItems: "center" }}>
          <MyButton
            onPress={() =>
              setBuyModal((prev) => ({
                ...prev,
                open: true,
              }))
            }
            style={{
              width: "100%",
              marginVertical: 10,
              justifyContent: "center",
              alignItems: "center",
              paddingVertical: 10,
              backgroundColor: orange,
            }}
            textStyle={{ textAlign: "center", fontSize: 20 }}
            text="خرید آموزش"
          />
        </View>
      )}

      <View style={{ height: 100 }}></View>

      <PdfModal
        open={pdfModal.open}
        url={pdfModal.url}
        onClose={() => setPdfModal((prev) => ({ ...prev, open: false }))}
      />
      <BuyTutorial
        open={buyModal.open}
        store={buyModal.store}
        id={buyModal.id}
        onClose={() => setBuyModal((prev) => ({ ...prev, open: false }))}
        setRefreshing={setChange}
      />
    </ScrollView>
  );
}
